import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ListItem from "@material-ui/core/ListItem";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import { setAppbarTitle, setDrawerTextWidth, setDrawerWidth } from "../../../actions/ui";
import { setCurrentType } from "../../../actions/projectmail";
import { PROJECTMAIL } from "../../../constants/router";

// import Notification from "./Notification";
import NotificationBell from "./NotificationBell";

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    fontSize: "1rem",
  },
  minWidth: props => (props.minWidth ? { minWidth: props.minWidth + "px" } : {}),
  icon: { color: "rgba(0,0,0,0.54)" },
  expandDrawerIcon: { minWidth: theme.spacing(7) },
  noDisplay: {
    visibility: "hidden",
    fontSize: "1rem",
  },
  notification: {
    paddingLeft: theme.spacing(1),
  },
}));

const NavigationItemComponent = ({
  onClickFn,
  title,
  type,
  sideDrawerOpen,
  icon,
  sideDrawerTextWidth,
  setDrawerTextWidthFn,
  setDrawerWidthFn,
}) => {
  const textNode = useRef();
  const [minWidth, setMinWidth] = useState(undefined);

  useEffect(() => {
    if (textNode.current) {
      if (sideDrawerTextWidth < textNode.current.clientWidth) {
        setMinWidth(0);
        setDrawerWidthFn(150 + textNode.current.clientWidth); // 180
        setDrawerTextWidthFn(textNode.current.clientWidth);
      }
      if (minWidth !== sideDrawerTextWidth) {
        setMinWidth(sideDrawerTextWidth);
      }
    }
  }, [sideDrawerTextWidth, setDrawerTextWidthFn, setMinWidth, minWidth, setDrawerWidthFn]);

  const classes = useStyles({ minWidth });
  return sideDrawerOpen ? (
    <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${PROJECTMAIL}/${type}`}>
      <ListItem button className={classes.nested} key={type} onClick={() => onClickFn(type)}>
        <div className={`${classes.icon} ${classes.expandDrawerIcon}`}>{icon}</div>
        <div className={`${classes.title} ${classes.minWidth}`}>{title}</div>
        {/* <div className={classes.notification}>
          <Notification type={type} />
        </div>
        */}
        <NotificationBell type={type} />
        <div ref={textNode} className={classes.noDisplay}>
          {title}
        </div>
      </ListItem>
    </NavLink>
  ) : (
    <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${PROJECTMAIL}/${type}`}>
      <ListItem button className={classes.nested} key={type} onClick={() => onClickFn(type)}>
        <div className={classes.icon}>{icon}</div>
        {/** <Notification type={type} /> */}
      </ListItem>
    </NavLink>
  );
};

NavigationItemComponent.propTypes = {
  onClickFn: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  sideDrawerOpen: PropTypes.bool.isRequired,
  icon: PropTypes.object.isRequired,
  sideDrawerTextWidth: PropTypes.number.isRequired,
  setDrawerTextWidthFn: PropTypes.func.isRequired,
  setDrawerWidthFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  sideDrawerOpen: state.ui.sideDrawerOpen,
  sideDrawerTextWidth: state.ui.sideDrawerTextWidth,
});

const mapDispatchToProps = dispatch => ({
  onClickFn: type => {
    dispatch(setAppbarTitle("projectmail"));
    dispatch(setCurrentType(type));
  },
  setDrawerTextWidthFn: width => dispatch(setDrawerTextWidth(width)),
  setDrawerWidthFn: width => dispatch(setDrawerWidth(width)),
});

const NavigationItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationItemComponent);

export default NavigationItem;
